import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <span className="pointer-events-none absolute select-none font-heading text-[7rem] font-black text-background-200 md:text-[12rem]">
        404
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-600">
          <i className="ri-film-line text-3xl" aria-hidden="true" />
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm text-foreground-500">
          没有找到你想访问的内容，它可能已经下架或被移动了。
        </p>
        <p className="mt-1 font-mono text-xs text-foreground-400">
          {location.pathname}
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
          >
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            浏览影视分类
          </Link>
        </div>
      </div>
    </div>
  );
}